<div class="app-isf-ocr-quick-fix-consolidator-details">
  <div class="app-isf-ocr-quick-fix-consolidator-details__header">
    <div class="app-isf-ocr-quick-fix-consolidator-details__header__left">
      <p class="app-isf-ocr-quick-fix-consolidator-details__header__title">
        {{ "ENTITY.CONSOLIDATOR" | translate | uppercase }}
      </p>

      <app-hint-tooltip-icon [hint]="'INFO.CS.SUB_TITLE' | translate"></app-hint-tooltip-icon>
    </div>
  </div>

  <div class="app-isf-ocr-quick-fix-consolidator-details__row">
    <p class="app-isf-ocr-quick-fix-consolidator-details__text m-0">
      {{ "INFO.CS.SUB_TITLE" | translate }}
    </p>
    <p class="app-isf-ocr-quick-fix-consolidator-details__hint-text">{{ "LABELS.USE_PREV_INFO" | translate }}</p>
  </div>

  <div class="app-isf-ocr-quick-fix-consolidator-details__row">
    <app-entity-unify-card
      *ngIf="!!seller && isEditMode"
      [entity]="seller"
      [formGroup]="formGroup"
      [code]="enumEntityModelCode.CONSOLIDATOR"
      [selectedValueControl]="formGroup.get('id')"
      [labelOverride]="'INFO.CS.USE_SE_DESKTOP'"
      [isDesktop]="isDesktop"
    ></app-entity-unify-card>
  </div>

  <div class="app-isf-ocr-quick-fix-consolidator-details__row">
    <app-section-form-block-layout
      *ngIf="!!consolidatorFields"
      [formGroup]="formGroup"
      [editBlockDescription]="!!seller && isEditMode ? 'LABELS.OR_ADD_DETAILS' : ''"
      [fields]="consolidatorFields"
      [displayFields]="consolidatorDisplayFields"
      [displayErrors]="displayErrors"
      [formErrors]="formErrors"
      [isEditBlockOpenByDefault]="isAnyFormBlockFieldEmpty(consolidatorFields, formGroup)"
      [isHideBorder]="true"
      editBlockClass="normal-gap"
      (edit)="onBlockEdit($event)"
    >
      <address-update
        edit-block-body
        [formGroup]="formGroup"
        [code]="enumEntityModelCode.CONSOLIDATOR"
        [errors]="formErrors"
        [isShowState]="true"
        [isShowCountry]="true"
        [isDesktop]="true"
        [defaultCountry]="null"
        [isFilterRestrictedCountries]="false"
      ></address-update>
    </app-section-form-block-layout>
  </div>

  <ng-container *ngIf="isEditMode">
    <hr class="app-isf-ocr-quick-fix-consolidator-details__hr" />

    <div class="app-isf-ocr-quick-fix-consolidator-details__clear-form-btn" (click)="onClearForm()">
      <i class="fa fa-trash btn-remove-icon"></i>
      {{ "FORM_LABEL.CLEAN_FORM" | translate }}
    </div>
  </ng-container>

  <missing-fields [code]="'LABELS.ISF'" (decline)="onSubmit(false)"></missing-fields>
</div>
